import {useState} from "react";

import {AntdTable} from "@/components/custom/AntdTable/AntdTable.jsx";
import {BillOfMaterial} from "@/variants/index.js";
import {Link} from "react-router-dom";

export const createIHLink = (operator, material) => (
	<Link target="_blank" rel="noopener noreferrer" to={`/data?operator=${operator}&material=${material}`}>
		{material}
	</Link>
);

export const BomDataTab = ({equipment}) => {
	const [tableParams, setTableParams] = useState({
		pagination: {
			current: 1,
			pageSize: 50,
		},
	});

	function handleTableChange(pagination, filters, sorter) {
		setTableParams({
			pagination,
			filters,
			...sorter,
		});
	}

	return (
		<AntdTable
			tableSize={"small"}
			scroll={300}
			pagination={tableParams.pagination}
			onChange={handleTableChange}
			data={BillOfMaterial.getRows(equipment)}
			columns={BillOfMaterial.getColumns(equipment)}
			data-testid="bom-data-tab-table"
		/>
	);
};
